import React from "react";
import styled from "styled-components";
import { Modal } from "@material-ui/core";
import {
  formatDate,
  getStatusColor,
  getStatusIcon,
  TimelineWrapper,
  Timeline,
  TimelineDot,
  TimelineEvent,
  EventContent,
  EventHeader,
  EventLocation,
  EventTime,
  EventType,
  AWBNumber,
  LastUpdated,
  StatusBadge,
  StatusIcon,
  ShipmentCard,
  ShipmentHeader,
} from "../index";

const TrackingTimeLine = ({ modal, setModal }) => {
  return (
    <Modal
      open={modal?.state}
      onClose={() => setModal({ state: false })}
      disableRestoreFocus={true}
    >
      <ModalWrapper>
        <HeaderSection>
          <HeaderContent>
            <Title>Shipment Tracker</Title>
            <CloseButton onClick={() => setModal({ state: false })}>
              ✕
            </CloseButton>
          </HeaderContent>
        </HeaderSection>

        <ScrollableContent>
          {modal?.trackingData.map((shipment) => (
            <ShipmentCard key={shipment.awb_no}>
              <ShipmentHeader>
                <ShipmentInfo>
                  <AWBNumber>{shipment.awb_no}</AWBNumber>
                  <LastUpdated>{formatDate(shipment.status_date)}</LastUpdated>
                </ShipmentInfo>
                <StatusBadge colors={getStatusColor(shipment.status)}>
                  <StatusIcon>{getStatusIcon(shipment.status)}</StatusIcon>
                  {shipment.status}
                </StatusBadge>
              </ShipmentHeader>

              <TimelineWrapper>
                <Timeline>
                  {shipment.event.map((scan, idx) => (
                    <TimelineEvent
                      key={idx}
                      isLast={idx === shipment.event.length - 1}
                      isFirst={idx === 0}
                    >
                      <TimelineDot isLast={idx === shipment.event.length - 1} />
                      <EventContent>
                        <EventHeader>
                          <EventLocation>
                            {typeof scan.location === "string"
                              ? scan.location
                              : ""}
                          </EventLocation>
                          <EventTime>{formatDate(scan.status_date)}</EventTime>
                        </EventHeader>
                        <EventType>{scan.remarks}</EventType>
                      </EventContent>
                    </TimelineEvent>
                  ))}
                </Timeline>
              </TimelineWrapper>
            </ShipmentCard>
          ))}
        </ScrollableContent>
      </ModalWrapper>
    </Modal>
  );
};

export default TrackingTimeLine;

const ModalWrapper = styled.div`
  width: 90%;
  max-width: 600px;
  height: 50vh;
  max-height: 800px;
  background: white;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  overflow: hidden;

  @media (max-width: 768px) {
    width: 95%;
    height: 90vh;
    max-height: 90vh;
    border-radius: 16px;
  }
`;

const HeaderSection = styled.div`
  background: linear-gradient(135deg, #00838c 0%);
  padding: 20px;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
`;

const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.h1`
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: white;
  letter-spacing: -0.5px;

  @media (max-width: 600px) {
    font-size: 20px;
  }
`;

const CloseButton = styled.button`
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  font-size: 24px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: scale(1.1);
  }
`;

const ScrollableContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  background: #f8f9fa;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(102, 126, 234, 0.3);
    border-radius: 3px;

    &:hover {
      background: rgba(102, 126, 234, 0.5);
    }
  }
`;

const ShipmentInfo = styled.div`
  flex: 1;
  min-width: 0;
`;
